import React ,{useEffect, useState} from 'react';
import { Table, Button, Space, Input, Modal} from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { StudentScore } from '_components/studentScoreList'
import {useStudentScoreAction} from '_actions';
import { useClassWrapper, useFetchWrapper } from '_helpers';
import { DownloadForm } from '_components/studentScoreList';


export { StudentScoreTable };

function StudentScoreTable(props){
    var data =  JSON.parse(JSON.stringify(props.data));
    const studentScoreAction = useStudentScoreAction();
    const fetchWrapper = useFetchWrapper();
    const classWrapper = useClassWrapper();

    data = studentScoreAction.handleData(data);

    const [state, setState] = useState({
        searchText: '', 
        searchedColumn: '',
        visible : false,
        currentRow: {
          _id: '',
          key: 1,
          name: 'Nguyễn văn A ' + 1,
          tags: (1 % 2) ? ['Bình thường'] : ['Cảnh cáo'],
          date_of_birth: 1%30 + 1 + '/1/2001',
          email: 1 + 19021000 + '@vnu.edu.vn',
          student_id: 19020000 + 1,
        },
      });

    const [downloadPanelVisible, setDownloadPanelVisible] = useState(false);
    const [sortedInfo, setSortedInfo] = useState({ columnKey: 'name', order: 'ascend' });
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handler = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);

    const handleDownloadCancel = () => {
      setDownloadPanelVisible(false);
    };

    const showDownloadPanel = () => {
      console.log("button clicked")
      setDownloadPanelVisible(true);
      console.log(downloadPanelVisible);
    };
   
    
    let handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setState({
          ...state,
          searchText: selectedKeys[0],
          searchedColumn: dataIndex,
        });
      };
    
    let handleReset = clearFilters => {
        clearFilters();
        setState({ ...state, searchText: '' });
      };

    function save(blob, fileName) {
        if (window.navigator.msSaveOrOpenBlob) { // For IE:
            navigator.msSaveBlob(blob, fileName);
        } else { // For other browsers:
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
        }
    }
      
    let handleShowScoreboard = (record) =>{
      // console.log(record)
        setState({
          ...state,
          currentRow : record,
          visible : true});
        // setCurrentStudent(state.currentRow.student_id);
        // studentScoreAction.getScoreByID(state.currentRow.student_id);
        // console.log("getScoreByID triggered");

    }

    let handleCloseModal = () => {
        setState({
          ...state,
          visible : false,
      })
    }

    let searchInput;
    let getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }}>
            <Input
              ref={node => {
                  searchInput = node;
              }}
              placeholder={`Search ${dataIndex}`}
              value={selectedKeys[0]}
              onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
              onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
              style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
              <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{ width: 90 }}
              >
                Search
              </Button>
              <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                Reset
              </Button>
              <Button
                type="link"
                size="small"
                onClick={() => {
                  confirm({ closeDropdown: false });
                  setState({
                    ...state,
                    searchText: selectedKeys[0],
                    searchedColumn: dataIndex,
                  });
                }}
              >
                Filter
              </Button>
            </Space>
          </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? 'var(--accent)' : undefined }} />,
        onFilter: (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
        onFilterDropdownVisibleChange: visible => {
          if (visible) {
            setTimeout(() => searchInput.select(), 100);
          }
        },
        render: text =>
          state.searchedColumn === dataIndex ? (
            <Highlighter
              highlightStyle={{ backgroundColor: 'var(--warn-bg)', padding: 0 }}
              searchWords={[state.searchText]}
              autoEscape
              textToHighlight={text ? text.toString() : ''}
            />
          ) : (
            text
          ),
      });

      
        const columns = [
        {
            title: 'Họ và tên',
            dataIndex: 'name',
            key: 'name',
            width: 90,
            fixed: 'left',
            ...getColumnSearchProps('name'),
            sortOrder: sortedInfo.columnKey === 'name' ? sortedInfo.order : null,
            sorter: (a, b) => {
                const viMap = {'à':'a','á':'a','ả':'a','ã':'a','ạ':'a','ă':'a','ắ':'a','ằ':'a','ẳ':'a','ẵ':'a','ặ':'a','â':'a','ấ':'a','ầ':'a','ẩ':'a','ẫ':'a','ậ':'a','è':'e','é':'e','ẻ':'e','ẽ':'e','ẹ':'e','ê':'e','ế':'e','ề':'e','ể':'e','ễ':'e','ệ':'e','ì':'i','í':'i','ỉ':'i','ĩ':'i','ị':'i','ò':'o','ó':'o','ỏ':'o','õ':'o','ọ':'o','ô':'o','ố':'o','ồ':'o','ổ':'o','ỗ':'o','ộ':'o','ơ':'o','ớ':'o','ờ':'o','ở':'o','ỡ':'o','ợ':'o','ù':'u','ú':'u','ủ':'u','ũ':'u','ụ':'u','ư':'u','ứ':'u','ừ':'u','ử':'u','ữ':'u','ự':'u','ỳ':'y','ý':'y','ỷ':'y','ỹ':'y','ỵ':'y','đ':'d'};
                const normalize = s => (s || '').toLowerCase().split('').map(c => viMap[c] || c).join('');
                const lastName = name => normalize((name || '').trim().split(' ').pop());
                return lastName(a.name) < lastName(b.name) ? -1 : lastName(a.name) > lastName(b.name) ? 1 : 0;
            },
            render: (text, record) => (
                <div className="sc2-name-cell">
                    <div className="sc2-name-text">
                        <span className="sc2-name">{text}</span>
                        <span className="sc2-id">{record.student_id || '—'}</span>
                    </div>
                    <button
                        type="button"
                        className="sc2-icon-btn"
                        title={"Xem bảng điểm " + record.name}
                        onClick={() => handleShowScoreboard(record)}
                    >
                        <InfoCircleOutlined />
                    </button>
                </div>
            ),
        },
        {
            title: 'Trạng thái',
            key: 'tags',
            width: 75,
            dataIndex: 'tags',
            filters: [
                {
                  text: 'Chưa nộp học phí',
                  value: 'chưa nộp học phí',
                },
                {
                  text: 'Chưa đủ tín',
                  value: 'chưa đủ tín',
                },
                {
                  text: 'Cảnh cáo',
                  value: 'cảnh cáo',
                },
                {
                  text: 'Bình thường',
                  value: 'bình thường',
                },
                {
                  text: 'Đuổi học',
                  value: 'đuổi học',
                },
              ],
            onFilter: (value, record) => {
              return record.tags.includes(value.toLowerCase())
            },
            render: tags => (
                <span>
                {tags.map(tag => {
                    let tone = 'bad';
                    if (tag === 'bình thường') {
                        tone = 'ok';
                    } else if (tag === 'cảnh cáo' || tag === 'chưa nộp học phí' || tag === 'chưa đủ tín') {
                        tone = 'warn';
                    } else if (tag === 'chưa có điểm') {
                        tone = 'pending';
                    }
                    return (
                        <span className={`tag tag-${tone}`} key={tag}>
                            {tag}
                        </span>
                    );
                })}
                </span>
            )
        },
        {
            title: 'Ngày sinh',
            width: 65,
            dataIndex: 'date_of_birth',
            key: 'date_of_birth',
        },
        {
          title: 'TBCTL',
          width: 45,
          dataIndex: 'cpa',
          key: 'cpa',
          sorter: {
            compare: (a, b) => parseFloat(a.cpa) - parseFloat(b.cpa),
            multiple: 5,
          },
      },
    ]
    return (
        <div className="att2-page soft-in">
            <div className="att2-head">
                <div className="att2-head-l">
                    <h1 className="att2-title">Bảng điểm học sinh</h1>
                </div>
                <div className="att2-tools">
                    <Button type="primary" onClick={() => showDownloadPanel()}>Tải bảng điểm</Button>
                </div>
            </div>
            <div className="float-panel soft-in-scale">
                <Table
                className="score-table"
                columns={columns}
                dataSource={data}
                scroll={{ x: 'max-content' }}
                onChange={(_, __, sorter) => {
                    const s = Array.isArray(sorter) ? sorter[0] : sorter;
                    setSortedInfo(s?.order ? s : {});
                }}
                />
            </div>
            <Modal title="Tải bảng điểm" visible={downloadPanelVisible} onCancel={handleDownloadCancel} footer={[]}> 
              <DownloadForm classId = {classWrapper.curClass.class_id}/>
            </Modal>
            <Modal
              title="Bảng điểm học sinh"
              visible={state.visible}
              onCancel= {handleCloseModal}
              footer={[]}
              width={1100}
            >
              <StudentScore student_id={state.currentRow.student_id} isPersonal={false} class_id={classWrapper.curClass?.class_id}/>
            </Modal>
        </div>
    )
  } 
